export default __webpack_public_path__ + "static/media/plus.ea78f0be.svg";